import {
  FlatAspect,
  ItemAttributeOption,
} from "@/models/HomePageSearchResponse";

// AJB: spell color throughout?
const COLOUR_OPTIONS: FlatAspect[] = [
  { id: "190", label: "Bay", slug: "bay" },
  { id: "194", label: "Black", slug: "black" },
  { id: "191", label: "Brown", slug: "brown" },
  { id: "242", label: "Buckskin", slug: "buckskin" },
  { id: "246", label: "Champagne", slug: "champagne" },
  { id: "192", label: "Chestnut", slug: "chestnut" },
  { id: "195", label: "Coloured", slug: "coloured" },
  { id: "244", label: "Cremello", slug: "cremello" },
  { id: "193", label: "Grey", slug: "grey" },
  { id: "241", label: "Palomino", slug: "palomino" },
  { id: "245", label: "Perlino", slug: "perlino" },
  { id: "247", label: "Pinto", slug: "pinto" },
  { id: "240", label: "Roan", slug: "roan" },
];

export default COLOUR_OPTIONS;

export const COLOUR_ATTRIBUTE_OPTIONS: ItemAttributeOption[] =
  COLOUR_OPTIONS.map((colour) => ({
    value: colour.id,
    label: colour.label,
  }));
